<template>
    <v-col cols="12" md="6">
        <div class="text-right">
            <v-btn text small color="error" @click="handleDeleteButtonClick">Delete specialist</v-btn>
        </div>
        <client-specialist-form
                        :clientSpecialist="clientSpecialist"
                        ref="client-specialist-update-form"
                        :errorMessagesByFields="validationErrors('updateClientSpecialist')"
                        @validation-changed="handleFormValidationChanged"
                        @fieldChanged="handleFieldChanged"/>
        <div>
            <v-spacer></v-spacer>
            <v-btn color="success" :disabled="!saveButtonActive" @click="handleSaveButtonClick"
                   :loading="progress('updateClientSpecialist')">
                Save
            </v-btn>
            <v-btn class="ml-2" @click="handleCancelButtonClick">
                Cancel
            </v-btn>
        </div>
        <confirm ref="delete-confirm"></confirm>
    </v-col>
</template>

<script>
    import _ from 'lodash'
    import {mapActions, mapGetters, mapState} from 'vuex'
    import ClientSpecialistForm from '../Components/ClientSpecialistForm'
    import Confirm from '../../Common/Confirm'

    export default {
        name: "UpdateClientSpecialist",
        components: {
            ClientSpecialistForm,
            Confirm
        },
        props: {
            clientId: String,
            specialistId: String
        },
        data () {
            return {
                formValid: false
            }
        },
        mounted () {
            this.formValid = this.$refs['client-specialist-update-form'].isFormValid()
        },
        computed: {
            ...mapState('clients', {
            }),
            ...mapGetters('clients', {
                clientsById: 'clientsById',
                progress: 'progress',
                validationErrors: 'validationErrors',
                validationErrorsByField: 'validationErrorsByField'
            }),
            saveButtonActive () {
                return this.formValid && !this.progress('updateClientSpecialist')
            },
            clientSpecialist () {
                const clientSpecialistById = _.keyBy(_.get(this.clientsById, [this.clientId, 'specialists'], {}), 'id')
                return _.get(clientSpecialistById, this.specialistId, {})
            }
        },
        methods: {
            ...mapActions({
                update: 'clients/updateClientSpecialist',
                delete: 'clients/deleteClientSpecialist',
                resetValidationErrorsByField: 'clients/resetValidationErrorsByField'
            }),
            async handleSaveButtonClick () {
                const formData = this.$refs['client-specialist-update-form'].getFormData()
                const updateResult = await this.update(formData)

                if (!updateResult) {
                    return
                }
            },
            handleFormValidationChanged (value) {
                this.formValid = value
            },
            handleCancelButtonClick () {
                this.$refs['client-specialist-update-form'].reset()
                this.$router.push({path: `/clients/${this.clientId}/specialists`})
            },
            handleFieldChanged ({fieldName}) {
                if (_.get(this.validationErrorsByField, ['updateClientSpecialist', fieldName], false)) {
                    return
                }

                this.resetValidationErrorsByField({context: 'updateClientSpecialist', fieldName: fieldName})
            },
            handleDeleteButtonClick () {
                this.$refs['delete-confirm'].open('Delete specialist', `Do you want to delete specialist: "${this.clientSpecialist.name}"?`, {width: 600}).then(async (confirm) => {
                    if (!confirm) {
                        return
                    }

                    try {
                        const deleted = await this.delete(this.clientSpecialist)
                        if (deleted) {
                          this.$router.push({path: `/clients/${this.clientId}/specialists`})
                        }
                    } catch (e) {
                        console.log(e)
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>